import { render, staticRenderFns } from "./ShainSetteiK.vue?vue&type=template&id=67d1b57a&scoped=true"
import script from "./ShainSetteiK.vue?vue&type=script&lang=js"
export * from "./ShainSetteiK.vue?vue&type=script&lang=js"
import style0 from "./ShainSetteiK.vue?vue&type=style&index=0&id=67d1b57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1b57a",
  null
  
)

export default component.exports